






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  @Prop({ type: Boolean, default: false }) readonly spaceBottom?: boolean
}
